(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rf-amazon"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const campaign = document.querySelector('[data-rf-campaign]');
    if (!campaign || campaign.dataset.eventsBound) return;
    campaign.dataset.eventsBound = 'true';
    const publish = (name, detail) => {
      if (!window.Shopify?.analytics?.publish || window.Shopify.designMode) return;
      try {
        const result = window.Shopify.analytics.publish(name, {
          ...detail,
          product_handle: campaign.dataset.productHandle,
          page_version: campaign.dataset.rfCampaign
        });
        if (result?.catch) result.catch(() => {});
      } catch {}
    };
    campaign.addEventListener('click', (event) => {
      const link = event.target instanceof Element ? event.target.closest('[data-rf-amazon]') : null;
      if (!link) return;
      publish('royal_formula:amazon_outbound_click', { placement: link.dataset.rfAmazon });
    });
    campaign.querySelectorAll('details').forEach((details, index) => {
      details.addEventListener('toggle', () => {
        if (details.open) publish('royal_formula:campaign_engagement', { action: 'faq_open', item: String(index + 1) });
      });
    });
    const video = campaign.querySelector('video');
    video?.addEventListener('play', () => publish('royal_formula:campaign_engagement', { action: 'video_play' }), { once: true });
    video?.addEventListener('ended', () => publish('royal_formula:campaign_engagement', { action: 'video_complete' }), { once: true });
    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          publish('royal_formula:campaign_engagement', { action: 'reviews_view' });
          observer.unobserve(entry.target);
        });
      }, { threshold: 0.35 });
      const reviews = campaign.querySelector('#rfc-reviews');
      if (reviews) observer.observe(reviews);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rf-reviews"] && !Shopify.designMode) return;
  try {
    
  if (!document.querySelector('script[src*="staticw2.yotpo.com/"]')) {
    const reviewsScript = document.createElement('script');
    reviewsScript.src = 'https://staticw2.yotpo.com/GurRiFNve8jZvIuh5kABss6IruGltTqj7Vi8Xnfq/widget.js';
    reviewsScript.async = true;
    document.head.appendChild(reviewsScript);
  }

  } catch(e) { console.error(e); }
})();
})();
